export const mastersRoutes = (apiBase) => ({
  // Valores Normales
  getValoresNormales: (consecutivo = "") =>
    `${apiBase}/valores-normales${consecutivo ? `?consecutivo=${consecutivo}` : ""}`,
  getValoresNormalesById: (id) => `${apiBase}/valores-normales-by-id?id=${id}`,
  saveValoresNormales: `${apiBase}/valores-normales`,
  deleteValoresNormales: `${apiBase}/valores-normales/eliminar`,

  // Codificación
  getCodificacion: (consecutivo = "") =>
    `${apiBase}/codificacion${consecutivo ? `?consecutivo=${consecutivo}` : ""}`,
  getCodificacionById: (id) => `${apiBase}/codificacion-by-id?id=${id}`,
  saveCodificacion: `${apiBase}/codificacion`,
  deleteCodificacion: `${apiBase}/codificacion/eliminar`,

  // Opciones de Codificación (ValorCodificacion)
  addValorCodificacion: `${apiBase}/codificacion/valor`,
  updateValorCodificacion: `${apiBase}/codificacion/valor`,
  deleteValorCodificacion: `${apiBase}/codificacion/valor/eliminar`,
});

